import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import NoteDS2SemUn from "./NoteDS2SemUn"

const NoteDS2 = props => {
  const [section, setSection] = useState(1)

  const renderBlock = section => {
    if (section === 1) {
      return <NoteDS2SemUn />
    }
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Compostage | Cresus </title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 1,
                  })}
                  onClick={() => {
                    setSection(1)
                  }}
                >
                  {props.t("Semstre 1")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 2,
                  })}
                  onClick={() => {
                    setSection(2)
                  }}
                >
                  {props.t("Semestre 2")}
                </NavLink>
              </NavItem>
            </Nav>
            {renderBlock(section)}
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

NoteDS2.propTypes = {
  t: PropTypes.any,
}
export default withRouter(withTranslation()(NoteDS2))
